import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AsyncActionStatus } from '../../../actions/common.actionTypes';
import NewCarousel from '../../Carousel/NewCarousel';
import useRouter from '../../../utils/useRouter';
import { numberOfSlides, routes } from '../../../constants';
import DashboardMuiCard from '../../cards/MuiCard/DashboardMuiCard';
import { selectPinnedContents, selectPinnedStatus } from '../../../reducers/pinned.selectors';
import { getCommonCardProps } from '../../Search/SearchResults/SearchResults';
import CardSkeleton from '../../Carousel/CardSkeleton';

const PinnedDocumentsCarousel: React.FC = () => {
  const { t } = useTranslation();
  const { router } = useRouter();
  const randomPinnedDocs = useSelector(selectPinnedContents);
  const pinnedStatus = useSelector(selectPinnedStatus);
  const slides = new Array(numberOfSlides.xl).fill(null);

  if (randomPinnedDocs.length < numberOfSlides.xl) return null;

  return (
    <NewCarousel 
      title={t('My pinned items')}
      onShowAll={() => router.push(`/${routes.pinned.root}`)}
    >
      {pinnedStatus === AsyncActionStatus.READY ? (
        randomPinnedDocs.map((pinnedItem, index) => (
          <DashboardMuiCard
            key={index}
            contentType={pinnedItem.type === 'product' ? 'product' : pinnedItem.fileType}
            {...getCommonCardProps(pinnedItem)} />
        ))
      ) : slides.map((_, index) => <CardSkeleton key={index} />)}
    </NewCarousel>

  );
};

export default React.memo(PinnedDocumentsCarousel);
